module.exports = __webpack_public_path__ + "img/01智慧园区.85f586d5.jpg";